import { useTheme } from '@mui/material/styles'
import * as React from 'react'

import Box, { BoxProps } from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'

type Props = BoxProps & {
  loading: boolean
}

export const BulkActionCircularProgress: React.FC<Props> = (props) => {
  const { loading, ...boxProps } = props

  const theme = useTheme()

  return loading ? (
    <Box mt={3} mx="auto" {...boxProps}>
      <CircularProgress
        color="primary"
        style={{ margin: `${theme.spacing(3)} auto` }}
      />
    </Box>
  ) : null
}
BulkActionCircularProgress.displayName = 'BulkActionCircularProgress'
